import {Box, Tab, Tabs, useTheme} from '@mui/material';
import {Link} from 'react-router-dom';
import {PageHeader} from '../page-header/page-header';

/**
 * Section tabs component used in our tabs components.
 */
export const SectionTabs = (props: {
  exitUrl: string;
  tabs: Array<{
    value: string;
    label: string;
    href: string;
  }>;
  title?: string;
  currentTab?: string;
  titleAvatar?: {
    type: 'user' | 'entity' | 'other';
    url?: string;
  };
  disabled?: boolean;
  rightButtons?: React.ReactNode;
}) => {
  const theme = useTheme();

  return (
    <Box sx={{width: '100%', display: 'flex', flexDirection: 'column'}}>
      <PageHeader
        title={props.title}
        rightButtons={props.rightButtons}
        titleAvatar={props.titleAvatar}
      />
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          flex: 1,
          justifyContent: 'center',
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tabs
          value={props.currentTab || false}
          sx={{
            '& .MuiTabs-flexContainer': {
              flexWrap: 'wrap',
              justifyContent: 'center',
            },
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          }}
        >
          {props.tabs.map((tab) => {
            return (
              <Tab
                key={`tab-list-item-${tab.value}`}
                label={tab.label}
                value={tab.value}
                component={Link}
                to={tab.href}
                disabled={props.disabled === true ? true : false}
                sx={{
                  borderBottom: 2,
                  borderColor:
                    props.currentTab === tab.value ? theme.palette.primary.main : 'transparent',
                  transition: 'all 0.25s',
                }}
              />
            );
          })}
        </Tabs>
      </Box>
    </Box>
  );
};
